<!--
 * @Author       : panyangyang
 * @Date         : 2026-08-25 16:25:25
 * @LastEditTime : 2026-09-04 10:27:34
 * @LastEditors  : panyangyang
 * @Description  : 大屏数据
 * @FilePath     : \ngs_platform_manage_admin\src\views\large-screen\index.vue
-->
<template>
	<div id="Map" class="dashboard">
		<!-- 顶部区域 -->
		<div class="top flex">
			<div class="w-30pe tab flex">
				<!-- tab -->
				<span
					v-for="item in tabArr"
					:key="item.name + 'tab'"
					:class="{ 'tab-item': true, active: activeTab == item.name }"
					@click="changeTab(item)"
					>{{ item.label }}</span
				>
				<!-- 日期选择框 -->
				<el-date-picker
					v-if="activeTab == '1' || activeTab == '2'"
					v-model="inputDate"
					:type="activeTab == '1' ? 'year' : activeTab == '2' ? 'month' : ''"
					:value-format="activeTab == '1' ? 'yyyy' : activeTab == '2' ? 'yyyy-MM' : ''"
					placeholder=""
					@change="getData"
				></el-date-picker>
			</div>
			<div class="flex-1 text-center title">安招采平台运营数据</div>
			<div class="w-30pe text-right">
				<div class="back-btn" @click="goBack">
					<img src="~@/assets/images/screen/back.png" alt="" />
					<span>退出</span>
				</div>
			</div>
		</div>

		<!-- 内容区域 -->
		<div class="content flex">
			<!-- 左侧区域 -->
			<leftPanel :leftData="leftData" :queryType="activeTab" :queryDate="inputDate"></leftPanel>

			<!-- 中间区域 -->
			<middlePanel :middleData="middleData"></middlePanel>

			<!-- 右侧区域 -->
			<rightPanel :rightData="rightData"></rightPanel>
		</div>
	</div>
</template>

<script>
import autofit from 'autofit.js'
import leftPanel from './left-panel/index.vue'
import middlePanel from './middle-panel/index.vue'
import rightPanel from './right-panel/index.vue'
import * as Api from '@/api/modules/large-screen.js'

export default {
	components: { leftPanel, middlePanel, rightPanel },
	data() {
		return {
			inputDate: '', // 日期输入框
			//
			activeTab: '0',
			tabArr: [
				{ label: '总量', name: '0' },
				{ label: '年度', name: '1' },
				{ label: '月度', name: '2' },
				{ label: '当天', name: '3' }
			],
			// 左侧面板数据
			leftData: {},
			// 中间面板数据
			middleData: {},
			// 右侧面板数据
			rightData: {}
		}
	},
	created() {
		this.getData()
	},
	mounted() {
		autofit.init({
			dh: 920,
			dw: 1920,
			el: '#Map',
			resize: true
		})
	},
	methods: {
		// 获取大屏数据
		getData() {
			const params = {
				queryType: this.activeTab, // 0：总量；1：年度；2：月度；3：当天
				queryDate: this.inputDate
			}
			Api.getScreenInfo(params).then((res) => {
				const {
					incomeArr = [], // 收入分类
					proInfo = {}, // 项目分类
					topTenArr = [], // 前十公司
					amountInfo = {}, // 累计金额
					onlineArr = [], // 在线人数
					instantArr = [], // 及时收入
					flowArr = [], // 流量转化漏斗
					picArr = [], // 用户画像
					projectBudgetArr = [], // 项目画像
					projectArr = [], // 项目画像
					cityArr = [] // 主要城市数据
				} = res.data

				this.leftData = {
					incomeArr,
					proInfo,
					topTenArr
				}
				this.middleData = {
					amountInfo,
					onlineArr,
					instantArr
				}
				this.rightData = {
					flowArr,
					picArr,
					projectBudgetArr,
					projectArr,
					cityArr
				}
			})
		},

		// 切换tab
		changeTab(item) {
			this.activeTab = item.name
			this.inputDate = ''

			if (item.name == '1') {
				// 默认今年
				this.inputDate = this.$utils.toDateString(new Date(), 'yyyy')
			} else if (item.name == '2') {
				// 默认本月
				this.inputDate = this.$utils.toDateString(new Date(), 'yyyy-MM')
			} else if (item.name == '3') {
				// 默认当天
				// this.inputDate = this.$utils.getWhatDay(new Date(), 0, 'first')
			}

			this.getData()
		},

		goBack() {
			window.close()
		}
	}
}
</script>

<style lang="less" scoped>
// 文字颜色渐变
.text-gradient {
	background-image: linear-gradient(to bottom, #76b6f5 0%, #edf4fc 100%);
	-webkit-background-clip: text;
	background-clip: text;
	color: transparent;
}
// 背景图设置
.image-set {
	background-size: 100% 100%;
	background-repeat: no-repeat;
}
.dashboard {
	width: 100%;
	height: 100%;
	overflow: auto;
	background-image: url('~@/assets/images/screen/screen-bg.jpg');
	.image-set;
	position: relative;
	padding: 0px 30px 30px;
	color: #fff;
	box-sizing: border-box;

	// 顶部标题
	.top {
		height: 81px;
		padding-top: 20px;
		.title {
			font-weight: 800;
			font-size: 40px;
			color: #ffffff;
			line-height: 60px;
			text-shadow: 0px 0px 10px #5ba1e7;
			margin-top: -18px;
		}
		.back-btn {
			font-size: 16px;
			display: inline-block;
			cursor: pointer;
			position: relative;
			img {
				width: 33px;
				height: 33px;
				margin-right: 10px;
				position: absolute;
				position: absolute;
				right: 30px;
				top: -5px;
			}
		}
	}

	.w-30pe {
		width: 30%;
	}
	.flex-1 {
		flex: 1;
	}
}

/deep/ .el-date-editor {
	width: 120px;
	height: 34px;
	margin-left: 10px;
}
/deep/ .el-input__inner {
	height: 34px;
	color: #ffffff;
	background-color: transparent;
	border: 2px solid #3ba1ff;
	box-shadow: inset 0px 0px 30px 0px #60adf9;
}

// 公共样式tab
/deep/ .tab {
	// 带边框
	.tab-item {
		display: flex;
		height: 34px;
		line-height: 32px;
		padding: 0 14px;
		margin-left: 10px;
		font-size: 14px;
		color: #60adf9;
		border-radius: 6px;
		border: 2px solid #3ba1ff;
		opacity: 0.58;
		cursor: pointer;
		&.active {
			color: #ffffff;
			box-shadow: inset 0px 0px 30px 0px #60adf9;
			border-radius: 6px;
			border: 2px solid #3ba1ff;
			opacity: 0.8;
			transition: box-shadow 0.3s;
		}
	}

	// 只带下边框
	.tab-item-line {
		width: 130px;
		font-weight: 400;
		font-size: 18px;
		color: #60adf9;
		line-height: 25px;
		text-align: center;
		position: relative;

		&.line2 {
			width: 95px;
		}

		&.active {
			.text-gradient;
			.line {
				position: absolute;
				bottom: -2px;
				left: 50%;
				transform: translateX(-50%);
				width: 50px;
				height: 4px;
				background: #b8e2f1;
				border-radius: 3px;
				transition: all 0.3s;
			}
		}
	}
}

// 公共样式card
/deep/ .card {
	padding: 15px 13px;
	min-height: 0;
	display: flex;
	flex-direction: column;

	.card-content {
		flex: 1;
		min-height: 0;
		margin-top: 15px;
	}

	.card-header {
		.text-gradient;
		font-weight: 600;
		font-size: 18px;
		line-height: 25px;
		padding-left: 22px;
		position: relative;

		&::before {
			position: absolute;
			left: 0;
			top: 3px;
			content: '';
			width: 16px;
			height: 17px;
			background-image: url('~@/assets/images/screen/header-icon.png');
			.image-set;
		}
	}
}

// 公共样式chart
/deep/ .chart-container {
	flex: 1;
	min-height: 0;
}

.content {
	width: 100%;
	height: calc(100% - 81px);
	color: #ffffff;
	box-sizing: border-box;
	gap: 16px;

	// 自定义滚动条样式
	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	::-webkit-scrollbar-track {
		background: rgba(255, 255, 255, 0);
	}

	::-webkit-scrollbar-thumb {
		background: rgba(255, 255, 255, 0.1);
		border-radius: 3px;
	}

	::-webkit-scrollbar-thumb:hover {
		background: rgba(255, 255, 255, 0.2);
	}
}
</style>
